var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContact(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 55.8809,
    height: 55.8809,
    rx: 14,
    fill: "#FCDDD8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.3894 20.3557C32.406 20.5541 33.4151 21.0024 34.1474 21.7347C34.8798 22.4671 35.3281 23.4761 35.5264 24.4927M32.0789 15.5293C34.1909 15.7639 36.0914 16.7856 37.5949 18.2873C39.0984 19.7889 40.1155 21.6915 40.3528 23.8032M40.352 34.1133V37.8501C40.3579 39.2785 39.0735 40.4713 37.6313 40.3412C25.1841 40.3509 15.5312 30.6084 15.541 18.2448C15.4111 16.8103 16.598 15.5308 18.0246 15.5294H21.7687C22.3744 15.5235 22.9616 15.7375 23.4208 16.1317C24.7265 17.2523 25.5663 21.0559 25.2431 22.568C24.9909 23.7485 23.8009 24.5744 22.9918 25.3819C24.7685 28.5002 27.3555 31.0822 30.48 32.8553C31.2891 32.0479 32.1167 30.8602 33.2995 30.6084C34.8169 30.2854 38.645 31.1265 39.7611 32.4412C40.1569 32.9074 40.3672 33.5025 40.352 34.1133Z",
    stroke: "#F8AA9E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.90dd498078b90f0e659d03077541c51e.svg";
export { ForwardRef as ReactComponent };